import type messageZh from '../zh/message';

const message: typeof messageZh = {
  qr_sample: 'Mẫu đã gửi, vui lòng chú ý nhận hàng',
  qr_video: 'Sau khi đăng video hãy báo cho tôi',
  qr_commission: 'Hoa hồng có thể thương lượng thêm',
  qr_thanks: 'Cảm ơn đã hợp tác',
  load_failed: 'Tải hội thoại thất bại',
  pending_reply_failed: 'Không tải được số hội thoại chờ trả lời',
  message_load_failed: 'Tải tin nhắn thất bại',
  archived_toast: 'Đã lưu trữ hội thoại. Có thể tìm trong Đã lưu trữ',
  restored_toast: 'Đã khôi phục hội thoại về hộp thư',
  starred_toast: 'Đã thêm dấu sao',
  unstarred_toast: 'Đã bỏ dấu sao',
  star_failed: 'Không cập nhật được dấu sao',
  archive_failed: 'Không cập nhật được lưu trữ',
  mark_read: 'Đánh dấu đã đọc',
  marked_read: 'Đã đánh dấu đã đọc',
  mark_read_failed: 'Không đánh dấu được đã đọc',
  offline: 'Ngoại tuyến',
  starred: 'Đã gắn sao',
  star: 'Gắn sao',
  view_profile: 'Xem hồ sơ',
  profile_missing: 'Chưa có hồ sơ KOL',
  title: 'Tin nhắn',
  refresh_failed: 'Làm mới thất bại',
  history_failed: 'Tải tin nhắn cũ thất bại',
  template_soon: 'Mẫu tin sắp ra mắt',
  empty: 'Chưa có tin nhắn, hãy gửi một lời chào',
  profile_title: 'Hồ sơ KOL',
  inbox: 'Hộp thư',
  broadcast: 'Nhiệm vụ gửi hàng loạt',
  quota_tip: 'Tối đa {{limit}} tin trước khi KOL trả lời',
  today_quota: 'Hạn mức còn lại',
  quota_shop_label: 'Cửa hàng',
  quota_mail_label: 'Email',
  quota_unlimited: 'Không giới hạn',
  quota_shop_detail: 'Cửa hàng còn {{remaining}} / {{total}}, gói {{plan}}, thêm {{addon}}, đã dùng {{used}}',
  quota_mail_detail: 'Email còn {{remaining}} / {{total}}, gói {{plan}}, thêm {{addon}}, đã dùng {{used}}',
  quota_mail_unlimited_detail: 'Email không giới hạn, gói {{plan}}, thêm {{addon}}, đã dùng {{used}}',
  quota_reset: 'Hạn mức gói đến {{time}}',
  quota_load_failed: 'Không tải được hạn mức',
  create_broadcast: 'Tạo nhiệm vụ gửi hàng loạt',
  filter_all: 'Tất cả',
  unread: 'Chưa đọc',
  unreplied: 'Chưa trả lời',
  archived: 'Đã lưu trữ',
  refresh: 'Làm mới',
  mark_all_read: 'Đánh dấu tất cả đã đọc',
  more: 'Thêm',
  search_placeholder: 'Tìm KOL / tin nhắn',
  no_match: 'Không có hội thoại phù hợp',
  empty_inbox: 'Chưa có hội thoại',
  tiktok_talent: 'KOL TikTok',
  tiktok_dm: 'Tin nhắn TikTok',
  location: 'Vị trí',
  session_messages: 'Tin trong hội thoại',
  message_count: '{{count}} tin',
  last_message: 'Tin gần nhất',
  session_status: 'Trạng thái hội thoại',
  pending: 'Chờ trả lời',
  unbound_hint: 'KOL này chưa liên kết với cửa hàng. Mời KOL liên kết để hợp tác lâu dài.',
  start_invite: 'Tạo lời mời định hướng',
  send_bind: 'Gửi lời mời liên kết',
  view_homepage: 'Xem trang cá nhân',
  restore: 'Khôi phục hội thoại',
  archive: 'Lưu trữ hội thoại',
  hidden_product: 'Không hiển thị',
  col_task: 'Nhiệm vụ',
  col_progress: 'Tiến độ',
  col_status: 'Trạng thái',
  col_reply: 'Trả lời',
  col_product: 'Thẻ sản phẩm',
  col_actions: 'Thao tác',
  task_total: 'Tổng {{count}}',
  list_hint:
    'Gửi hàng loạt đi qua hàng đợi, phản hồi vào Hộp thư. Trước khi gửi sẽ loại danh sách đen / đã tiếp cận trong 7 ngày / KOL hủy đăng ký.',
  detail_title: 'Gửi hàng loạt · {{name}}',
  reply_rate: 'Tỷ lệ trả lời',
  created_at: 'Thời gian tạo',
  status_sending: 'Đang gửi',
  status_queued: 'Xếp hàng',
  status_done: 'Hoàn tất',
  status_paused: 'Đã tạm dừng',
  campaign_QUEUED: 'Đang xếp hàng',
  campaign_SENDING: 'Đang gửi',
  campaign_COMPLETED: 'Đã hoàn tất',
  campaign_PARTIAL_FAILED: 'Một phần thất bại',
  campaign_CANCELLED: 'Đã hủy',
  campaign_load_failed: 'Không tải được nhiệm vụ gửi hàng loạt',
  success_count: 'Đã gửi thành công',
  fail_count: 'Thất bại',
  reply_count: 'Đã trả lời',
  name_fallback: 'Gửi hàng loạt',
  quota_warn: 'Đã tạo. Hạn mức còn lại hôm nay {{count}} tin, phần vượt sẽ gửi vào ngày mai',
  created: 'Đã tạo nhiệm vụ gửi hàng loạt, {{count}} KOL vào hàng đợi gửi',
  create_title: 'Tạo nhiệm vụ gửi tin nhắn hàng loạt',
  task_name: 'Tên nhiệm vụ',
  task_name_placeholder: 'Nhập tên nhiệm vụ',
  task_name_required: 'Vui lòng nhập tên nhiệm vụ',
  body_required: 'Vui lòng nhập nội dung gửi',
  send_body: 'Nội dung gửi',
  template_placeholder: 'Chọn mẫu tin',
  template_empty: 'Cửa hàng này chưa có mẫu tin nhắn',
  product_empty: 'Cửa hàng này chưa có sản phẩm để gắn',
  product_id: 'ID sản phẩm',
  product_id_placeholder: 'Nhập ID sản phẩm',
  product_id_required: 'Vui lòng nhập ID sản phẩm',
  create_failed: 'Không tạo được nhiệm vụ gửi hàng loạt',
  create: 'Tạo',
  selected_skip: 'Đã chọn {{count}} KOL. Trước khi gửi sẽ loại danh sách đen / đã tiếp cận trong 7 ngày',
  show_product: 'Hiển thị thẻ sản phẩm',
  pick_product_card: 'Chọn thẻ sản phẩm ({{shop}})',
  price_rate: '{{price}} · Hoa hồng {{rate}}%',
  queue_hint: 'Gửi hàng loạt vào hàng đợi và được gửi sau. KOL trả lời sẽ vào Hộp thư.',
  preview_image: '[Hình ảnh]',
  preview_file: '[Tệp] {{name}}',
  blocked_archived: 'Hội thoại đã lưu trữ. Khôi phục để tiếp tục gửi',
  blocked_quota: 'Đã dùng hết hạn mức tin nhắn hôm nay ({{limit}} tin), đặt lại lúc 0 giờ ngày mai',
  blocked_limit: 'Trước khi đối phương trả lời chỉ gửi tối đa {{limit}} tin, đã gửi {{sent}}/{{limit}}. Vui lòng đợi KOL trả lời',
  send_unavailable: 'Chưa kết nối API gửi tin nhắn',
  send_failed: 'Không gửi được tin nhắn',
  send_success: 'Đã gửi tin nhắn'
};

export default message;
